import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { requestInitalData } from 'actions/assign';
import { ORDER, COLUMNS } from 'constants/config';
import AssignableCollection from '../shared/AssignableCollection';
import Search from '../shared/Search';
import Filter from '../shared/Filter';
import Sort from '../shared/Sort';

class AssigneesView extends PureComponent {
  componentDidMount() {
    this.props.requestInitalData();
  }

  static sortOptions = [
    {
      order: ORDER.ASC,
      type: COLUMNS.NAME,
      label: t('contents.assign_modal.sorts.name_A_Z'),
    },
    {
      order: ORDER.DESC,
      type: COLUMNS.NAME,
      label: t('contents.assign_modal.sorts.name_Z_A'),
    },
    {
      order: ORDER.DESC,
      type: COLUMNS.LAST_MODIFIED,
      label: t('contents.assign_modal.sorts.recently_updated'),
    },
  ];

  static filterOptions = [
    {
      value: 'User',
      label: t('contents.assign_modal.assignees.filters.people'),
    },
    {
      value: 'Group',
      label: t('contents.assign_modal.assignees.filters.groups'),
    },
  ];

  render() {
    return (
      <div className="AssignModal-detailsView">
        <Search
          placeholder={t('contents.assign_modal.assignees.search_placeholder')}
          getFiltersRef={() => this.filters}
          tabIndex="0"
        />
        <div
          ref={n => {
            this.filters = n;
          }}
          className="AssignModal-filters"
        >
          <Filter options={this.constructor.filterOptions} />
          <Sort options={this.constructor.sortOptions} />
        </div>
        <AssignableCollection />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  requestInitalData() {
    dispatch(requestInitalData());
  },
});

export default connect(null, mapDispatchToProps)(AssigneesView);
